import { useEffect, useState } from "react";
import { Icon } from "../Icon/icon";

export const Accordion = ({
  mainText = "",
  subText = "",
  isOpen = false,
  onOpen = () => {},
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <div className="p-6 rounded-xl bg-grey-100 flex flex-col gap-[10px]">
      <div className="flex gap-2 justify-between">
        <p className="text-lg lg:text-2xl text-deep-primary font-medium">
          {mainText}
        </p>

        <button
          type="button"
          className={`w-fit`}
          onClick={() => {
            setOpen(!open);
            onOpen();
          }}
        >
          <Icon
            svg={open ? "accordion-close" : "accordion-open"}
            width={24}
            height={24}
            className="transition-all duration-500"
          />
        </button>
      </div>

      <div
        className={`text-sm lg:text-base text-grey-800 font-medium overflow-hidden ${
          open ? "max-h-96 transition-all duration-1000" : "max-h-0"
        }`}
      >
        {subText}
      </div>
    </div>
  );
};
